import {
  CLOUD_ACCOUNTS_LIST_REQUEST,
  CLOUD_ACCOUNTS_LIST_SUCCESS,
  CLOUD_ACCOUNTS_LIST_ERROR,
  CLOUD_ACCOUNTS_LIST_SET,
  DELETE_CLOUD_ACCOUNTS_REQ,
  INTEGRATION_ACCOUNT_VIEW_PREFERENCES_REQ,
  SAVE_INTEGRATION_ACCOUNT_VIEW_PREFERENCES
} from './integration-accounts.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import { discoveryAccountsMetaInfo } from '@/column-header/integration_accounts/discovery-accounts.meta'
import { OrderByEnum } from '@/constants/orderby.constants'

const state = {
  cloudIntegrationAccountsReqStatus: '',
  cloudIntegrationAccounts: {},
  cloudIntegrationSummary: {
    accountCount: 0,
    vmCount: 0,
    containersCount: 0,
    agentInstalledCount: 0,
    detectionsCount: 0,
    progressionCount: 0,
    unhealthyCount: 0
  },
  integrationAccountPreferences: []
}

const getters = {
  cloudIntegrationAccountsReqStatus: state => state.cloudIntegrationAccountsReqStatus,
  cloudIntegrationAccounts: state => state.cloudIntegrationAccounts,
  cloudIntegrationSummary: state => state.cloudIntegrationSummary,
  integrationAccountPreferences: state => state.integrationAccountPreferences
}

// Best Practice - updates state
const mutations = {
  [CLOUD_ACCOUNTS_LIST_REQUEST]: state => (state.cloudIntegrationAccountsReqStatus = 'loading'),
  [CLOUD_ACCOUNTS_LIST_SUCCESS]: state => (state.cloudIntegrationAccountsReqStatus = 'saved'),
  [CLOUD_ACCOUNTS_LIST_ERROR]: state => (state.cloudIntegrationAccountsReqStatus = 'error'),
  [CLOUD_ACCOUNTS_LIST_SET]: (state, data) => {
    state.cloudIntegrationAccounts = data
    state.cloudIntegrationSummary.accountCount = data.models.length
    state.cloudIntegrationSummary.vmCount = _.sum(_.map(data.models, 'numVms'))
    state.cloudIntegrationSummary.containersCount = _.sum(_.map(data.models, 'numContainers'))
    state.cloudIntegrationSummary.agentInstalledCount = _.sum(_.map(data.models, 'numManaged'))
    state.cloudIntegrationSummary.detectionsCount = _.sum(_.map(data.models, 'numDetections'))
    state.cloudIntegrationSummary.progressionCount = _.sum(_.map(data.models, 'numProgressions'))
    state.cloudIntegrationSummary.unhealthyCount = _.filter(data.models, { status: 'UNHEALTHY' }).length
    state.cloudIntegrationSummary.unhealthyAwsCount = _.filter(data.models, {
      status: 'UNHEALTHY',
      source: 'AWS'
    }).length
    state.cloudIntegrationSummary.unhealthyGCPCount = _.filter(data.models, {
      status: 'UNHEALTHY',
      source: 'GCP'
    }).length
    state.cloudIntegrationSummary.unhealthyAzureCount = _.filter(data.models, {
      status: 'UNHEALTHY',
      source: 'AZURE'
    }).length
  },
  [INTEGRATION_ACCOUNT_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.integrationAccountPreferences = data
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [INTEGRATION_ACCOUNT_VIEW_PREFERENCES_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUserIntegrationAccountsPrefs = data.find(pref => {
            return pref.tbl_id === 16 && pref.user_id === uid
          })
          context.commit(INTEGRATION_ACCOUNT_VIEW_PREFERENCES_REQ, currUserIntegrationAccountsPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_INTEGRATION_ACCOUNT_VIEW_PREFERENCES] (context, payload) {
    console.log('Payload: ', payload)
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [CLOUD_ACCOUNTS_LIST_REQUEST] (context, integration) {
    context.commit(CLOUD_ACCOUNTS_LIST_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest()
        .get(`/integrations/accounts/discovery`)
        .then(({ data }) => {
          let integrationAccounts = context.rootState.integrations.integrationList
          // merge discovery account with integrationList for health status and scan freq
          data = _.map(data, account => {
            let foundAcct = integrationAccounts[account.accountKey]
            if (foundAcct) {
              // { accountKey: "DISCOVERY-4"
              // numContainers: 3
              // numDetections: 13215
              // numManaged: 10
              // numProgressions: 2
              // numVms: 566
              // type: "AWS" }
              account = _.merge(account, foundAcct)
              if (account.config) {
                account.nickName = account.config.nickName
              } else {
                account.nickName = account.accountKey
              }
              if (!account.enabled) {
                account.status = 'DISABLED'
              }
              if (account.enabled && !account.status) {
                account.status = 'INITIALIZING'
              }
            }
            // only supporting aws July 2021
            switch (account.type) {
              case 'AZUREDISCOVERY':
                account.source = 'AZURE'
                break
              case 'GCPDISCOVERY':
                account.source = 'GCP'
                break
              default:
                account.source = 'AWS'
            }
            return account
          })
          data = new IQCollection(
            data,
            { attributes: discoveryAccountsMetaInfo.meta.columns },
            { defaultSort: 'nickName', sortOrder: OrderByEnum.DESC }
          )
          context.commit(CLOUD_ACCOUNTS_LIST_SET, data)
          context.commit(CLOUD_ACCOUNTS_LIST_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(CLOUD_ACCOUNTS_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [DELETE_CLOUD_ACCOUNTS_REQ] (context, integrationId) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .delete(`/integrations/accounts/discovery/${integrationId}`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/integration_accounts/cloudintegration-accounts.module.js